import axios from 'axios'
import { getUserInfo } from './cache'

axios.defaults.timeout = 30 * 1000

const HEADERS = { 'Content-Type': 'application/x-www-form-urlencoded' }

// get请求URL的参数
// const serializeJSON = data => {
//   if (!data) {
//     return ''
//   }
//   return Object.entries(data).map(([key, value]) => {
//     return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
//   }).join('&')
// }

// get请求
// export const get = (url, params = {}) => {
//   let serializeBody = serializeJSON(params.body)
//   let realBody = serializeBody ? '?' + serializeBody : ''
//   let headers = params.headers ? params.headers : {}
//   return axios({
//     method: 'get',
//     url: url + realBody,
//     headers: { ...HEADERS, ...headers }
//   })
//     .then(res => handleResp(res))
//     .catch((error) => {
//       console.log(`【${url}】返回异常 `, error)
//       failCallback(createFailRespObj('网络异常'))
//       throw error
//     })
// }

// post请求
export const post = (url, params = { body: {} }) => {
  let headers = params.headers ? params.headers : {}
  // 从getUserInfo中获取token
  const userInfo = getUserInfo()
  if (userInfo && userInfo.token) {
    headers.token = userInfo.token
  } else {
    headers.token = ''
  }
  return axios({
    method: 'post',
    url: url,
    data: params.body,
    headers: { ...HEADERS, ...headers }
  })
    .then(res => handleResp(res))
    .catch((error) => {
      console.log(`【${url}】返回异常 `, error)
      failCallback(createFailRespObj('网络异常'))
      throw error
    })
}

/** 对返回结果进行处理 */
const handleResp = (resp) => {
  let respData = resp.data
  let status = resp.status
  if (status === 200) {
    return respData
  }
}

/** 弹窗提示 */
const showAlert = (msg) => {
  alert(msg)
}

const failCallback = (resp) => {
  if (resp && resp.resultMsg) {
    showAlert(resp.resultMsg)
  }
}

const createFailRespObj = (errorMsg) => {
  return { resultMsg: errorMsg }
}
